import React from "react";
import { Link } from "@reach/router";

const Button = ({ text, to, active, className }) => {
    return (
        <Link to={to} className={
            (
                "inline-flex my-auto font-bold rounded-full px-6 h-12 mx-1 text-center cursor-pointer shadow-lg text-gray-200 " +
                (active ? "bg-red-500 hover:bg-opacity-90" : "bg-black bg-opacity-75 hover:bg-opacity-50")
            ) + " " + (className || '')
        }


            getProps={({ isCurrent }) => {
                return {
                    class: (
                        "inline-flex my-auto font-bold rounded-full px-6 h-12 mx-1 text-center cursor-pointer shadow-lg text-gray-200 " +
                        (isCurrent ? "bg-red-500 hover:bg-opacity-90" : "bg-black bg-opacity-75 hover:bg-opacity-50")
                    )
                };
            }}

        >
            <div className="my-auto mx-auto">
                {text}
            </div>
        </Link>
    );
};

export default Button;
